import { render, staticRenderFns } from "./manageproducts.vue?vue&type=template&id=092d1386&scoped=true&"
import script from "./manageproducts.vue?vue&type=script&lang=js&"
export * from "./manageproducts.vue?vue&type=script&lang=js&"
import style0 from "./manageproducts.vue?vue&type=style&index=0&lang=css&"
import style1 from "./manageproducts.vue?vue&type=style&index=1&id=092d1386&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092d1386",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VCombobox,VContainer,VDataTable,VFlex,VIcon,VImg,VLayout,VTextField})
